<template>
    <!-- eslint-disable-next-line @maltjoy/eslint-rules/no-html-button -->
    <button
        class="navbar__back"
        :class="{'navbar__back--open': isVisible}"
        aria-label="Back to menu"
        data-testid="navbar-back"
        @click="$emit('click')"
    >
        <VJoyIcon name="arrow-left" size="xsmall" color="neutral-50" />
    </button>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    defineProps<{
        isVisible: boolean;
    }>();

    defineEmits<{
        click: [];
    }>();
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .navbar__back {
        position: absolute;
        top: 50%;
        left: var(--joy-core-spacing-6);
        display: flex;
        align-items: center;
        justify-content: center;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        opacity: 0;
        transform: translate3d(var(--joy-core-spacing-6), -50%, 0);
        transition:
            opacity calc(var(--navbar-transition-duration) * 0.4) var(--navbar-transition-easing),
            transform var(--navbar-transition-duration) var(--navbar-transition-easing);
        pointer-events: none;
        will-change: transform, opacity;
        backface-visibility: hidden;

        &--open {
            opacity: 1;
            transform: translate3d(0, -50%, 0);
            pointer-events: auto;
            transition-delay: calc(var(--navbar-transition-duration) * 0.6), 0s;
        }
    }

    @include mq.screen_md(min) {
        .navbar__back {
            display: none;
        }
    }
</style>
